import Modal from './modal';
import type { ModalType } from './types';

type Props = {
  id: string;
  size: Extract<ModalType['size'], 'xs' | 'sm'>;
  color?: Extract<ModalType['color'], 'white'>;
  title: React.ReactNode;
  content: React.ReactNode;
  submitButtonText: string;
  closeButtonText: string;
  closeOnClickOutside: boolean;
  modalSubmit: () => void;
  modalClose: () => void;
};

export default function ConfirmModal({
  id,
  size = 'xs',
  color = 'white',
  title,
  content,
  closeButtonText = '취소',
  submitButtonText = '확인',
  closeOnClickOutside,
  modalClose,
  modalSubmit,
}: Props) {
  return (
    <>
      <Modal.Overlay id={id} closeOnClickOutside={closeOnClickOutside} />
      <Modal size={size} color={color} isHeightAuto>
        <Modal.Body padding="48_32_32">
          {title && <Modal.Title title={title} />}
          {content && <Modal.Message content={content} />}
        </Modal.Body>

        <Modal.Footer
          buttonsInfo={[
            { closeButtonText, modalClose },
            { submitButtonText, modalSubmit },
          ]}
        />
      </Modal>
    </>
  );
}
